import { loginCompany, loginOrg } from '@/utils/LoginContext';
import request from '@/utils/request';

// 新增门店组
export async function save(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/saveStoreGroup`, {
    method: 'POST',
    body: payload,
  });
}
export async function query(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/page`, {
    method: 'POST',
    body: payload,
  });
}

export async function getStores(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/getByDcUuid?dcUuid=${payload.dcUuid}`);
}

// 根据uuid和门店代码名称查询门店组
export async function getByDcUuidAndStoreCodeName(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/getByDcUuidAndStoreCodeName?dcUuid=${payload.dcUuid}&storeCodeName=${payload.storeCodeName}`);
}

// 删除门店组
export async function remove(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/removeStoreGroup?dcUuid=${payload.dcUuid}&storeGroup=${payload.storeGroup}`,{
    method: 'DELETE'
  });
}

// 重命名门店组
export async function renameStores(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/renameStoreGroup?dcUuid=${payload.dcUuid}&newStoreGroup=${payload.newStoreGroup}&oldStoreGroup=${payload.oldStoreGroup}`, {
    method: 'POST'
  });
}

// 批量删除门店
export async function batchRemove(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/batchRemoveStore?dcUuid=${payload.dcUuid}&storeGroup=${payload.storeGroup}`, {
    method: 'DELETE',
    body: payload.storeUuids,
  });
}

// 批量新增
export async function batchAdd(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/batchSaveStore?dcUuid=${payload.dcUuid}&storeGroup=${payload.storeGroup}`, {
    method: 'POST',
    body: payload.stores,
  });
}

// 为门店组添加所有门店
export async function addStores(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/saveStore?dcUuid=${payload.dcUuid}&storeGroup=${payload.storeGroup}`, {
    method: 'POST'
  });
}

// 删除门店组内所有门店
export async function removeStores(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/removeStore?dcUuid=${payload.dcUuid}&storeGroup=${payload.storeGroup}`,{
    method: 'DELETE'
  });
}
//excel 批量导入
export async function batchImport(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/batchimport?companyUuid=${loginCompany().uuid}&fileKey=${payload.fileKey}`, {
    method: 'POST',
  });
}

export async function queryPageStore(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/pageStore`, {
    method: 'POST',
    body: payload,
  });
}

export async function adjustOrder(payload) {
  return request(`/iwms-wms/wms/storegroupconfig/adjustorder?dcUuid=${payload.dcUuid}&storeUuid=${payload.storeUuid}&groupName=${payload.groupName}&orderNo=${payload.orderNo}`, {
    method: 'POST'
  });
}

